import { FaBuilding, FaEnvelope, FaPhone } from 'react-icons/fa';
import { Tooltip } from 'react-tooltip';
import { formatAmountInThousands, formatDate } from '../../../service/utils/formatters';

const IssuerRow = ({
  issuer
}) => {
  const formatNumber = (num) => {
    if (num === null || num === undefined) return '-';
    return new Intl.NumberFormat('fr-FR').format(num);
  };

  const getMarketBadgeClass = (count) => {
    if (count === 0) return 'bg-secondary bg-opacity-10 text-secondary';
    if (count <= 2) return 'bg-success bg-opacity-10 text-success';
    if (count <= 5) return 'bg-warning bg-opacity-10 text-warning';
    return 'bg-danger bg-opacity-10 text-danger';
  };

  const getValueBadgeClass = (value) => {
    if (!value || value <= 0) return 'bg-secondary bg-opacity-10 text-secondary';
    if (value < 1000000) return 'bg-info bg-opacity-10 text-info';
    if (value < 10000000) return 'bg-success bg-opacity-10 text-success';
    if (value < 100000000) return 'bg-warning bg-opacity-10 text-warning';
    return 'bg-danger bg-opacity-10 text-danger';
  };

  return (
    <tr className="border-bottom align-middle hover-row">
      {/* Émetteur */}
      <td>
        <div className="d-flex align-items-center">
          <div className="avatar-sm primary bg-opacity-10 border border-primary border-opacity-25 rounded-circle me-3 d-flex align-items-center justify-content-center">
            <FaBuilding className="text-primary" size={16} />
          </div>
          <div>
            <h6 className="mb-0 fw-semibold">{issuer.issuerName}</h6>
          </div>
        </div>
      </td>

      {/* Contacts */}
      <td>
        <div className="d-flex flex-column gap-1">
          {issuer.email && (
            <div className="d-flex align-items-center">
              <FaEnvelope className="me-2 text-muted" size={12} />
              <small className="text-truncate" style={{ maxWidth: '200px' }}>
                {issuer.email}
              </small>
            </div>
          )}
          {issuer.phone && (
            <div className="d-flex align-items-center">
              <FaPhone className="me-2 text-muted" size={12} />
              <small>{issuer.phone}</small>
            </div>
          )}
          {!issuer.email && !issuer.phone && (
            <small className="text-muted">Aucun contact</small>
          )}
        </div>
      </td>

      {/* Statistiques principales */}
      <td className="text-center">
        <div className="d-flex flex-column align-items-center">
          <span 
            className={`badge ${getMarketBadgeClass(issuer.totalSecurities)} fw-semibold px-3 py-2`}
            data-tooltip-id={`securities-tooltip-${issuer.accountId}`}
          >
            {formatNumber(issuer.totalSecurities)} titres
          </span>
          <Tooltip id={`securities-tooltip-${issuer.accountId}`} place="top">
            <div className="text-start">
              <small>
                <strong>Répartition:</strong><br />
                • Public: {issuer.publicSecurities}<br />
                • Privé: {issuer.privateSecurities}<br />
                • Monétaire: {issuer.monetarySecurities}
              </small>
            </div>
          </Tooltip>
          {/* <small className="text-muted mt-1">
            {issuer.publicSecurities} pub / {issuer.privateSecurities} priv
          </small> */}
        </div>
      </td>

      {/* Unités émises */}
      <td className="text-center">
        <div className="d-flex flex-column align-items-center">
          <span className="badge bg-info bg-opacity-10 text-info fw-semibold">
            {formatNumber(issuer.totalUnitsIssued)}
          </span>
          {/* <small className="text-muted mt-1">unités totales</small> */}
        </div>
      </td>

      {/* Valeur totale */}
      <td className="text-end">
        <div className="d-flex flex-column align-items-end">
          <span 
            className={`badge ${getValueBadgeClass(issuer.totalValue)} fw-bold px-3 py-2`}
            data-tooltip-id={`value-tooltip-${issuer.accountId}`}
          >
            {formatAmountInThousands(issuer.totalValue)}
          </span>
          <Tooltip id={`value-tooltip-${issuer.accountId}`} place="top">
            Valeur totale des titres émis
          </Tooltip>
        </div>
      </td>

      <td>
        <small className="text-muted mt-1">
          {formatDate(issuer.lastIssueDate ?? issuer.firstIssueDate)}
        </small>
      </td>

      {/* Actions */}
      {/* <td className="text-center">
        <div className="d-flex justify-content-center gap-2">
          <button
            className="btn btn-sm btn-outline-primary d-flex align-items-center gap-1"
            onClick={() => onViewDetails(issuer.accountId)}
            data-tooltip-id={`view-tooltip-${issuer.accountId}`}
          >
            <FaEye size={12} />
            Détails
            <Tooltip id={`view-tooltip-${issuer.accountId}`} place="top">
              Voir les détails de l'émetteur
            </Tooltip>
          </button>
          
          <button
            className="btn btn-sm btn-outline-info d-flex align-items-center gap-1"
            onClick={() => console.log('Statistiques', issuer.accountId)}
            data-tooltip-id={`stats-tooltip-${issuer.accountId}`}
          >
            <FaChartBar size={12} />
            Stats
            <Tooltip id={`stats-tooltip-${issuer.accountId}`} place="top">
              Voir les statistiques détaillées
            </Tooltip>
          </button>
        </div>
      </td> */}
    </tr>
  );
};

export default IssuerRow;